import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-empty-pod-data',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './empty-pod-data.component.html',
  styleUrl: './empty-pod-data.component.css'
})
export class EmptyPodDataComponent {
  @Input() vat = '';
}
